<template>
    <b-modal :no-close-on-backdrop="true" :title="$t('create_new_vendor')" ref="innermodal">
        <div v-if="$v.$error" class="alert alert-danger x-error">
            <div class="error" v-if="!$v.model.Name.required">- សូមធ្វើការបញ្ជូលឈ្មោះចំណូល</div>
            <div class="error" v-if="!$v.model.Phone.required">- សូមធ្វើការបញ្ជូលលេខទូរសព្ទ</div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="flex-container">
                    <div>
                        <input type="file" ref="file" @change="fileChangeHandler" accept="image/*" style="display:none;"/>
                        <img :src="img" alt="" class="img-thumbnail" style="width: 135px;" @click="$refs.file.click()">
                    </div>
                    <div class="flex-right">
                        <div class="form-group" :class="{ 'form-group-error': $v.model.Name.$error }">
                            <label class="blue label-control">{{$t('name')}}</label>
                            <div>
                                <input type="text" class="form-control form-control-sm" v-model="$v.model.Name.$model" />
                            </div>
                        </div>
                        <div class="form-group">
                            <div>
                                <label class="blue" style="margin-right: 15px;">
                                    <input type="radio" name="type" value="1" v-model="model.TypeId"/> {{$t('company')}}
                                </label>
                                <label class="blue">
                                    <input type="radio" name="type" value="2" v-model="model.TypeId"/> {{$t('individual')}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="blue label-control">{{$t('latin_name')}}</label>
                    <div>
                        <input type="text" class="form-control form-control-sm" v-model="model.NameEng" />
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group" :class="{ 'form-group-error': $v.model.Phone.$error }">
                    <label class="blue label-control">{{$t('phone')}}</label>
                    <div>
                        <input type="text" class="form-control form-control-sm" v-model="$v.model.Phone.$model" />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="blue label-control">{{$t('email')}}</label>
                    <div><input type="text" class="form-control form-control-sm" v-model="model.Email" /></div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="blue label-control">{{$t('website')}}</label>
                    <div><input type="text" class="form-control form-control-sm" v-model="model.Website" /></div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="blue label-control">{{$t('address')}}</label>
            <div><input type="text" class="form-control form-control-sm" v-model="model.Address" /></div>
        </div>
        <div slot="modal-footer">
            <b-btn variant="primary" size="sm" @click="clickSaveHandler"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
    </b-modal>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
export default {
    props: {
        value: {
            type: Object,
            default: undefined
        },
        link: {
            type: String,
            default: 'vendor/save'
        }
    },
    data: function() {
        return {
            model: {
                Name: '',
                Phone: '',
                Email: '',
                TypeId: 1
            },
            actionLink: this.link,
            img: '/img/no-image.svg',
            formHead: {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        }
    },
    validations:{
        model: {
            Name: { required },
            Phone: { required }
        }
    },
    created: function(){
        if(this.value != undefined){
            this.model = this.value;
        }
    },
    methods: {
        clickSaveHandler: function() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                var loading = this.$loading.show();
                this.$api().post(this.actionLink, this.model).then(res => {
                    if(this.$isValid(res)){
                        var vendor = res.data.Json.Vendor;
                        this.$emit('done', vendor);
                        this.$refs.innermodal.hide();
                    }
                }).finally(function() { loading.hide(); });
            }
        },
        fileChangeHandler: function(e){
            const file = e.target.files[0];
            this.img = URL.createObjectURL(file);
        }
    },
    watch: {
        value(value){
            this.$v.$reset();
            if(value != undefined)
                this.model = value;
        },
        link(value){
            this.actionLink = value;
        }
    }
}
</script>
